/**
 * Whether any Composer banner applies, from the same facts that pick which one.
 *
 * This has to stay in step with `ChatComposerHeaderBanner`'s ladder rung for
 * rung. `ComposerSurface` draws the ruled box around the banner from this
 * answer and cannot see inside the element it is handed, so a rung missing here
 * either hides a real banner or leaves an empty strip above the prompt.
 *
 * Its own module because `ChatComposer.logic` is at its file-size cap, and this
 * is the answer two components have to agree on rather than one more helper in
 * a grab bag.
 */
export function hasComposerHeader(input: {
  isComposerDisabled: boolean;
  isComposerApprovalState: boolean;
  hasActiveActionRequired: boolean;
  pendingUserInputCount: number;
  showPlanFollowUpPrompt: boolean;
  hasActiveProposedPlan: boolean;
}): boolean {
  return (
    input.isComposerDisabled ||
    input.isComposerApprovalState ||
    input.hasActiveActionRequired ||
    input.pendingUserInputCount > 0 ||
    (input.showPlanFollowUpPrompt && input.hasActiveProposedPlan)
  );
}
